import Vue from 'vue';
import dateDifferenceInYears from 'date-fns/difference_in_years';
import validate from '../../vendor/validate';
import stepsValidate from './steps-validate';
import vueValidateStep from './vue-validate-step';
import injectCaptcha, {renderCaptchaScript} from '../inject-captcha';

export default function (selector) {
  const steps = document.querySelectorAll(selector);
  const reference = document.querySelector('#js-steps').dataset.formReference;

  if (!steps.length) {
    return;
  }

  renderCaptchaScript();

  const stepsForm = new Vue({
    name: reference,
    el: '#js-steps',
    delimiters: ['#{', '}'],
    data: {
      birthdate: {
        day: null,
        month: null,
        year: null,
        full: null
      },
      hcp: {
        number: null,
        float: null,
        full: null
      },
      currentStep: 1,
      formType: '',
      profile: {
        selectedMembership: '',
        paymentMethod: document.querySelector('[name="user_edit[paymentType]"]') ? document.querySelector('[name="user_edit[paymentType]"]').value : null,
        userPassword: null,
      },
      register: {
        selectedMembership: document.querySelector('.form[data-membership]') ? document.querySelector('.form[data-membership]').dataset.membership : 'MEMBERSHIP_FREE',
        paymentMethod: null,
        userPassword: null,
        membershipPrices: {},
        membershipPrice: {},
      },
      golfpros: {
        searchValue: '',
        list: {},
        filtered: {},
        activeId: null,
        activeItem: 0,
      },
    },
    computed: {
      autocomplete() {
        var obj = this.golfpros.list;

        for (var ding in Object.keys(obj)) {
          if (obj[ding].label === this.golfpros.searchValue) {
            console.log(obj[ding]);
          }
        }
      },
      userPasswordEncoded: {
        get () {
          const dataNode = reference === 'register' ? this.register : this.profile;
          return String(dataNode.userPassword).replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
        }
      }
    },
    methods: {
      /**
       * Validate birthday field
       */
      getFullBirthDate: function () {
        const self = this;
        this.birthdate.full = this.birthdate.year + '-' + this.birthdate.month + '-' + this.birthdate.day;

        // validate field after each change
        let dateValue = document.querySelector('.js-birth-date');

        setTimeout(function () {
          if (!validate.hasError(dateValue)) {
            validate.removeError(dateValue, 'error');
          }
        }, 10);

        if (this.birthdate.year && this.birthdate.month && this.birthdate.day) {
          const dateOfBirth = new Date(self.birthdate.year, (self.birthdate.month - 1), self.birthdate.day, 0, 0, 0);

          this.updateMemershipPrice(dateOfBirth);
        }
      },

      getMobileBirthDate: function () {
        const dateOfBirth = new Date(this.birthdate.full);

        this.updateMemershipPrice(dateOfBirth);
      },

      updateMemershipPrice: function (dateOfBirth) {
        const that = this;
        const now = new Date();
        let membershipPrice = 0;

        now.setHours(0);
        now.setMinutes(0);
        now.setSeconds(0);

        const age = dateDifferenceInYears(now, dateOfBirth);

        Object.keys(this.register.membershipPrices).forEach(function (element) {
          Object.keys(that.register.membershipPrices[element]).forEach(function (maxAge) {
            if (age > maxAge) {
              return;
            }

            if (membershipPrice > 0) {
              return;
            }

            membershipPrice = window.membershipPrices[element][maxAge];
            that.register.membershipPrice[element] = window.membershipPrices[element][maxAge];
          });

          membershipPrice = 0;
        });
      },

      /**
       * if full date is known, split it into days, months, years
       * & hide selects on mobile, show input-date.
       */
      birthDate: function () {
        const self = this;
        let dateValue = document.querySelector('.js-birth-date');

        // if full date is known, split it into days, months, years
        if (dateValue.attributes.value !== undefined) {
          self.birthdate.full = dateValue.attributes.value.value;
          const parts = self.birthdate.full.split('-');
          self.birthdate.day = parts[2];
          self.birthdate.month = parts[1];
          self.birthdate.year = parts[0];
        }

        // hide selects on mobile, show input-date.
        const birthDateDropdown = document.querySelector('.js-birth-date-dropdown');
        if (dateValue) {
          if (app.test.isMobileTabletDevice) {
            addClass(birthDateDropdown, 'form__entry__date--hidden');
            removeClass(dateValue, 'form__entry__date--hidden');
          }
        }
      },

      /**
       * Update the filtered list
       */
      filterGolfproList() {
        var obj = JSON.parse(this.golfpros.list);

        for (var ding in obj) {
          if(this.golfpros.searchValue === '') {
            this.golfpros.filtered[ding] = obj[ding];
          } else if (obj[ding].label.toLowerCase().includes(this.golfpros.searchValue.toLowerCase())) {
            this.golfpros.filtered[ding] = obj[ding];
          } else {
            delete this.golfpros.filtered[ding];
          }
        }
      },

      checkGolfproList() {
        var obj = JSON.parse(this.golfpros.list);
        let match = false;

        for (var ding in obj) {
          if (obj[ding].label.toLowerCase() === this.golfpros.searchValue.toLowerCase()) {
            match = true;
          }
        }

        if (this.golfpros.searchValue === '') {
          this.golfpros.filtered = {};
        }

        if (!match) {
          this.golfpros.searchValue = '';
          this.golfpros.activeId = null;
        }
      },

      /**
       * Enable arrow navigation in list
       */
      navigateGolfProList(event) {
        if (event.keyCode === 38 && this.golfpros.activeItem > 0) {
          this.golfpros.activeItem--;
        } else if (event.keyCode === 40 && this.golfpros.activeItem < (Object.keys(this.golfpros.filtered).length - 1)) {
          this.golfpros.activeItem++;
        } else if (event.keyCode === 13) {
          this.golfpros.activeId = this.golfpros.filtered[Object.keys(this.golfpros.filtered)[this.golfpros.activeItem]].value;
          this.golfpros.searchValue = JSON.parse(this.golfpros.list)[this.golfpros.activeId].label;
          this.golfpros.filtered = {};
          this.golfpros.activeItem = 0;
        }
      },

      /**
       * on Click, select golfpro
       * @param target
       */
      setGolfPro(target) {
        this.golfpros.activeId = target.id;
        this.golfpros.searchValue = JSON.parse(this.golfpros.list)[target.id].label;
        this.golfpros.filtered = {};
        this.golfpros.activeItem = 0;
      },

      /**
       * Update HCP
       */
      updateHcp: function (isNumber) {
        if (this.hcp.number >= 36) {
          this.hcp.float = 0;
        }

        if (isNumber && this.hcp.number !== '') {
          this.hcp.float = 0;
        }

        if (this.hcp.number === '') {
          this.hcp.float = '';
        }

        if (this.hcp.number > -9) {
          this.hcp.full = this.hcp.number + '.' + this.hcp.float;
        } else {
          this.hcp.full = null;
        }

        // validate field after each change
        let handicapValue = document.querySelector('.js-handicap');
        setTimeout(function () {
          if (!validate.hasError(handicapValue)) {
            validate.removeError(handicapValue, 'error');
          }
        }, 10);
      },

      /**
       * Validate given step
       * @returns {boolean}
       */
      validateStep: function () {
        return vueValidateStep(this.currentStep);
      },

      /**
       * Check if step is valid. If so, go to given step
       * @param currentStep
       */
      validateAndGoToStep: function (goToStep) {
        if (this.validateStep()) {

          if (reference === 'register' || reference === 'profile-edit') {
            // Step 1, or step 2, or step 3 != free
            if (goToStep === 1 || goToStep === 2 || (goToStep === 3 && this.register.selectedMembership !== 'MEMBERSHIP_FREE')) {
              this.currentStep = goToStep;
            } else {
              document.querySelector('.js-steps-form-validate').submit();
            }
          } else {

            this.currentStep = goToStep;
          }
        }
      },

      /**
       * Go (back) to a step
       */
      goToStep: function (goToStep) {
        // if (isNaN(goToStep)) {
        //   return;
        // }

        this.currentStep = goToStep;
      },

      submitWithReCaptcha: async function () {
        if (!this.validateStep()) {
          return;
        }

        (await injectCaptcha(
          document.querySelector('.js-steps-form-validate')
        )).submit();
      },

      /**
       * Get a parameter from the url
       */
      getUrlParameter: function (name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        const results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      },
    },
    mounted: function () {
      const self = this;

      this.$nextTick(function () {
        self.register.membershipPrices = window.membershipPrices;
        self.golfpros.list = window.golfProsList;

        if (reference === 'profile-edit') {
          self.profile.selectedMembership = document.querySelector('[data-user-role]').dataset.userRole;
          self.register.selectedMembership = document.querySelector('[data-user-role]').dataset.userRole;
          self.birthDate();
          self.getMobileBirthDate();
        }

        if (reference === 'profile-upgrade') {
          this.birthDate();
          this.getMobileBirthDate();
        }

        stepsValidate();
        self.birthDate();
        self.getFullBirthDate();

        const preferredGolfPro = document.querySelector('.form[data-golfpro]') ? document.querySelector('.form[data-golfpro]').dataset.golfpro : null;
        if (preferredGolfPro) {
          self.setGolfPro({id: preferredGolfPro});
        }
      });
    }
  });
};
